export default {
    DAL: {
        GCE: {
            REQUEST_PARAMS: 'GCERequestParams',
            CACHE_HIT: 'GCECacheHit',
            ACTIVE_RELOAD_REQUEST: 'GCEActiveReloadInProgress',
        },
        ICES: {
            REQUEST: 'InitializeCalEventStore',
            RELOAD_FROM_SESSION_STORAGE: 'ICESReloadFromSessionStorage',
            RELOAD_FROM_NETWORK: 'ICESReloadFromNetwork',
        },
        RCE: {
            REQUEST: 'ReloadCalEventsInCache',
            ALL_SESSION_STORAGE_EVENT_COUNT: 'RCEAllSessionStorageEventCount',
            SESSION_STORAGE_EVENT_STALE: 'RCESessionStorageEventStale',
            NETWORK_EVENT_COUNT: 'RCENetworkEventCount',
            DATE_RANGE_SET: 'CacheDateRangeSet',
            CALENDAR_EVENT_REQUESTS: 'GetCalendarEventRequestsMade',
            NETWORK_CALENDAR_EVENTS_RECEIVED: 'NetworkCalendarEventsReceived',
            REQUESTS_RETRIGGERED: 'RequestsRetriggered',
        },
        GCE_SERVICE: {
            CALENDAR_EVENTS_RESPONSE: 'GetCalendarEventsResponseReceived',
        },
    },
};
